import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { SiteShell } from '@/components/layout/SiteShell'
import { HomePage } from '@/pages/HomePage'
import { WorkRedirect } from '@/components/navigation/WorkRedirect'
import { WorkPage } from '@/pages/WorkPage'
import { CaseStudyRoutePage } from '@/pages/CaseStudyRoutePage'
import { CompanyInfoPage } from '@/pages/CompanyInfoPage'
import { LexFollowUpPage } from '@/pages/LexFollowUpPage'
import { NetworkUpdatePage } from '@/pages/NetworkUpdatePage'
import { OttSalmarFollowUpPage } from '@/pages/OttSalmarFollowUpPage'
import { AnonymousFollowUpPage, RainVaanaFollowUpPage } from '@/pages/RainVaanaFollowUpPage'
import { NotFoundPage } from '@/pages/NotFoundPage'

function LegacyWorkIndex() {
  const navigate = useNavigate()
  useEffect(() => { void navigate('/work/', { replace: true }) }, [navigate])
  return <WorkRedirect />
}

export const App = () => (
  <SiteShell>
    <Routes>
      <Route path="/" element={<HomePage />} />
      {['/blog', '/design', '/designv2'].map(path => <Route key={path} path={path} element={<LegacyWorkIndex />} />)}
      <Route path="/work" element={<WorkPage />} />
      <Route path="/blog/:slug" element={<CaseStudyRoutePage underBlog />} />
      <Route path="/case-studies/:slug" element={<CaseStudyRoutePage />} />
      <Route path="/custom-web" element={<NetworkUpdatePage />} />
      <Route path="/hello/ott-salmar-418632" element={<OttSalmarFollowUpPage />} />
      <Route path="/hello/rain-vaana-739284" element={<RainVaanaFollowUpPage />} />
      <Route path="/hello/mira-voss-604218" element={<AnonymousFollowUpPage />} />
      <Route path="/hello/lex-842917" element={<LexFollowUpPage />} />
      <Route path="/firm" element={<CompanyInfoPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </SiteShell>
)
